<template>
  <div class="analytics-page-margin">
    <div v-for="(item, index) in platformData" :key="item.title">
      <PlatformItem
        :id="item.id"
        :title="item.title"
        :introduction="item.introduction"
        :keyPoints="item.keyPoints"
        :imageFileName="item.imageFileName"
        :flipped="item.flipped"
        :findOutMoreLink="item.findOutMoreLink"
        :analyticsURL="item.analyticsURL"
      />
    <div v-if="index < platformData.length - 1" class="analytics-page-divider"/>
  </div>
  </div>
</template>

<script>
import AnalyticsData from "@/data/creditAnalytics.json";
import PlatformItem from "@/components/CreditAnalytics/PlatformItem.vue";

export default {
  name: 'Platform',
  components: {
    PlatformItem,
  },
  data() {
    return {
      platformData: AnalyticsData?.platform,
    };
  },
};
</script>
<style scoped lang="scss">
.analytics-page-margin {
  margin-top: calc(#{$mds-space-8-x} + #{$mds-space-three-quarter-x});
  margin-bottom: calc(#{$mds-space-8-x} + #{$mds-space-three-quarter-x});
}
.analytics-page-divider {
  height: 1px;
  background-color: #D5D5D5;
  margin-top: 45px;
  margin-bottom: 45px;
  margin-right: auto;
  margin-left: auto;
  max-width: 1360px;
  @media (max-width: $mds-breakpoint-m) {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
